import type { IPropertyBag } from '@deity-io/di-data-basics';
import { mapRecordToArray } from '@deity-io/di-data-basics';

export function isIProducerInstance(value: any): value is IProducerInstance {
  return 'producers' in value;
}

export interface ITimeStamped {
  since: number;
  last?: number;
  count: number;
}

export interface IProducerInstance {
  key: string;
  state: string;
  producers: Record<
    string,
    {
      key: string;
      type: string;
      initialized: boolean;
      proxy?: { type: string; queue: string };
    } & ITimeStamped
  >;
}

export interface IExternalInstance {
  key: string;
  state: string;
  components: Record<string, { component: string; method: string; path: string } & ITimeStamped>;
}

export interface IClusterStatePackage extends ITimeStamped {
  uuid: string;
  accountUuid: string;
  versionCount: number;
  pipelineCount: number;
  instances: Array<string>;
  versions: Record<
    string,
    {
      uuid: string;
      pipelineCount: number;
      pipelines: Record<
        string,
        {
          uuid: string;
          instances: Record<string, { uuid: string; producerCount: number; data: IPropertyBag } & ITimeStamped>;
        } & ITimeStamped
      >;
      instances: Array<string>;
    } & ITimeStamped
  >;
}

export interface IRuntimeState {
  services: Record<string, Record<string, { uuid: string }>>;
  packages: Record<string, IClusterStatePackage>;
}

export function filterServiceType(services: IRuntimeState['services'], key: string): string | undefined {
  return mapRecordToArray(services, (instances, instanceType) => {
    const b = mapRecordToArray(instances, (instance, instanceKey) => {
      if (instanceKey === key) {
        return instanceType;
      }

      return undefined;
    });
    if (b.length > 0) {
      return b[0];
    }

    return undefined;
  }).pop();
}
